import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Aggregate handlers on some node
 */
export var AggregatedEventCenter = /*#__PURE__*/function () {
  function AggregatedEventCenter() {
    _classCallCheck(this, AggregatedEventCenter);
    _defineProperty(this, "handlers", []);
  }
  _createClass(AggregatedEventCenter, [{
    key: "addHandler",
    value: function addHandler(handler) {
      if (this.handlers.indexOf(handler) !== -1) {
        throw new Error('Handler already attached');
      }
      this.handlers.push(handler);
    }
  }, {
    key: "connect",
    value: function connect(domNode, payload) {
      this.handlers.forEach(function (handler) {
        return handler.attachHandlers(domNode, payload);
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(domNode) {
      this.handlers.forEach(function (handler) {
        return handler.detachHandlers(domNode);
      });
    }
  }]);
  return AggregatedEventCenter;
}();